<div class="modal-header d-flex flex-row align-items-center justify-content-between">
  <div class="d-flex flex-row align-items-center p-2">
    <div class="chip-icon primary small">
      <div class="inner"><i class="ti ti-file"></i></div>
    </div>
    <span class="title ms-2">{{ document ? 'Editer un document' : 'Créer un document' }}</span>
  </div>
  <button class="button m icon transparent" (click)="close()"><i class="ti ti-x"></i></button>
</div>
<div class="modal-content d-flex flex-column align-items-start">
  <div class="info-message">
    <i class="ti ti-info-hexagon"></i>
    <p>
      <ng-container *ngIf="user.accessType === 'mutuelle'">
        Le document sera ajouté à la bibliothèque de l'entreprise qui sera notifiée par email.<br />
      </ng-container>
      Marquez le document comme "à compléter" si vous souhaitez que les salariés le complètent avant de l'envoyer à
      l'entreprise.
    </p>
  </div>
  <div class="mt-3 w-100">
    <app-document-manager [form]="documentForm"></app-document-manager>
  </div>
</div>
<div class="modal-footer d-flex flex-row align-items-center justify-content-end gap-2">
  <button class="button m" (click)="close()" type="button">Annuler</button>
  <button class="button m primary confirm" (click)="validate()" type="button" [disabled]="loading">
    Confirmer<ion-spinner *ngIf="loading" color="light" name="dots"></ion-spinner>
  </button>
</div>